export type ClientType = 'INDIVIDUAL' | 'ENTITY';

export type RiskTier = 'LOW' | 'MEDIUM' | 'HIGH';

export type KycStatus =
  | 'APPROVED'
  | 'PENDING'
  | 'REJECTED'
  | 'ENHANCED_DUE_DILIGENCE';

export const SOURCES_OF_FUNDS = [
  'Employment',
  'Business Income',
  'Investment Returns',
  'Inheritance',
  'Property Sale',
  'Pension',
  'Gift',
  'Other',
] as const;
export type SourceOfFunds = (typeof SOURCES_OF_FUNDS)[number];

export const BRANCHES = ['Canary Wharf', 'Mayfair', 'Edinburgh', 'Manchester'] as const;
export type Branch = (typeof BRANCHES)[number];

export interface ClientRecord {
  client_id: string;
  branch: string;
  onboarding_date: string;
  client_name: string;
  client_type: ClientType;
  country_of_tax_residence: string;
  annual_income: number;
  source_of_funds: string;
  pep_status: boolean;
  sanctions_screening_match: boolean;
  adverse_media_flag: boolean;
  risk_classification: RiskTier | '';
  kyc_status: KycStatus | '';
  id_verification_date: string | null;
  relationship_manager: string;
  documentation_complete: boolean;
}

export interface RulesConfig {
  version: string;
  description?: string;
  high: {
    booleanFlags: Array<'pep_status' | 'sanctions_screening_match' | 'adverse_media_flag'>;
    countries: string[];
  };
  medium: {
    clientTypes: ClientType[];
    countries: string[];
    incomeThreshold: number;
    sourcesOfFunds: string[];
  };
}

export interface ClassificationResult {
  tier: RiskTier;
  reasons: string[];
  rulesVersion: string;
}

export type AuditAction =
  | 'INTAKE_CREATED'
  | 'CSV_INGESTED';

export interface AuditEntry {
  id: string;
  timestamp: string; // ISO 8601 UTC
  actor: string; // relationship manager name (prototype: picked at session start)
  action: AuditAction;
  clientId: string;
  payload: ClientRecord;
  computedTier: RiskTier;
  reasons: string[];
  rulesVersion: string;
}

export interface CompletenessIssue {
  field: string;
  message: string;
}

export interface RecordFindings {
  computed: ClassificationResult;
  storedTier: RiskTier | '';
  discrepancy: boolean;
  incomplete: CompletenessIssue[];
}
